import FieldFactory from './FieldFactory.js'
import Util from './Util.js'

const logicalOps = [ 'or', 'and' ]

export default {
  id : 'Expression.FieldParser.LogicalField',
  type : 'logicalField',
  sort : -12,
  handles : ( field, context ) => {
    return field.type === 'ExpressionParser.Field' && !!Util.findRootToken( field.value, { token : logicalOps, context } )
  },
  parse : async ( field, context ) => {
    const hasAlias = Util.handleAlias( field.value, { context : { ...context, field } } )
    let value = field.value, alias
    if ( hasAlias ) {
      value = hasAlias.field
      alias = hasAlias.alias
    }
    const res = Util.findRootToken( value, { token : logicalOps, context } )
    // no need to null check res, the handles did it for us
    const operator = res.match
    const childContext = {
      ...context,
      field : { ...field, type : 'ExpressionField.logical', operator },
    }
    const left = (
      await FieldFactory.create(
        res.pre,
        { ...childContext, indexOffset : 0 }
      )
    )?.fields?.[0]
    const right = (
      await FieldFactory.create(
        res.post,
        { ...childContext, indexOffset : res.relativeLocation.postIndex }
      )
    )?.fields?.[0]

    const conditions = [], operatorLocations = [ {
      absolute : {
        startIndex : res.absoluteLocation.matchIndex,
        endIndex : res.absoluteLocation.matchIndex + operator.length,
      },
      relative : {
        startIndex : res.relativeLocation.matchIndex,
        endIndex : res.relativeLocation.matchIndex + operator.length,
      }
    } ]
    // I don't think left can ever be an array but for consistency we leave it
    if ( Array.isArray( left ) ) {
      conditions.push( ...left )
      if ( Array.isArray( left.operatorLocations ) ) {
        operatorLocations.push(
          ...left.operatorLocations
        )
      }
    } else {
      conditions.push( left )
    }
    if ( Array.isArray( right ) ) {
      conditions.push( ...right )
      if ( Array.isArray( right.operatorLocations ) ) {
        operatorLocations.push(
          ...right.operatorLocations
        )
      }
    } else {
      conditions.push( right )
    }

    if (
      context?.parenthesesDepth === res.parenthesesDepth &&
      context?.parent?.type === 'ExpressionField.logical' &&
      context?.parent?.operator === operator
    ) {
      if ( context?.includeAstInfo ) {
        conditions.operatorLocations = operatorLocations
      }
      return conditions
    }
    
    const toReturn = {
      type : 'ExpressionField.logical',
      operator,
      conditions,
    }
    if ( hasAlias ) {
      toReturn.alias = alias
    }
    if ( context?.includeAstInfo ) {
      toReturn.absoluteLocation = {
        startIndex : field.startIndex,
        endIndex : field.startIndex +
          ( hasAlias ? hasAlias.field.length : field.value.length ),
      }
      toReturn.relativeLocation = {
        startIndex : 0,
        endIndex : hasAlias ? hasAlias.field.length : field.value.length
      }
      toReturn.operatorLocations = operatorLocations
      toReturn.untrimmed = field.untrimmed
      if ( hasAlias ) {
        toReturn.aliasLocation = {
          absolute : hasAlias.absoluteLocation,
          relative : hasAlias.relativeLocation,
        }
      }
    }
    return toReturn
  }
}
